<template>
  <div class="join-form">
    <div class="join-form--left">
      <WelcomeSection />
    </div>
    <!-- <div v-if="form.state == 'QLD'" class="join-form--right">
      <div class="join-form--step step-two">
        <div class="step-two--intro">
            <h2>Thank you for your interest in joining the AMA Queensland Branch.</h2>
            <p>The AMA QLD Branch membership join form is currently being updated. If you are interested in joining please contact the Member Engagement team via <a href="mailto:memberservices@ama.com.au">memberservices@ama.com.au</a> or phone 1300 133 655. Our team will be able to either provide you with the digital join form when available or can facilitate your application over the phone. </p>
            <p>
              To understand the current AMA federation changes in Queensland <a href="/AMA-QLD-Information-and-FAQ">read our FAQ page</a>.
            </p>
        </div>
      </div>
    </div> -->
    <div class="join-form--right">
      <div class="join-form--step step-two">
        <div class="step-two--intro">
            <h2>Join online at the AMA ({{ form.state }}) website.</h2>
            <a :href="url" target="_blank" class="button button-blue button-nm text-white">
              Continue to AMA {{ form.state }} join form
            </a>
            <a @click.prevent="$emit('update:step', 1)" href="#">Start again</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import WelcomeSection from './WelcomeSection';
  export default {
    name:'step-two',
    props: ['form', 'step'],
    components: {
      WelcomeSection
    },
    data() {
      return {
        urls: {
          NSW: 'https://www.amansw.com.au/join-the-ama',
          WA: 'https://www.amawa.com.au/amamembership/join-the-ama/',
          VIC: 'https://workflows.amavic.com.au/workflow/join',
          //QLD: 'https://www.amaq.com.au/Web/Join/Individual/Web-01NewMemberCreateAccount.aspx?WebsiteKey=d4c31fa4-467a-4959-b48b-cae3ea93e516'
        }
      }
    },
    computed: {
      url() {
        const state = this.form.state;

        if (this.urls[state]) {
          return this.urls[state];
        }

        return 'https://ama.com.au/joinnow';
      }
    },
    methods: {},
    mounted() {}
  }
</script>




